import nexus from 'nexus'
import thunkWrapper from 'redux/thunks/thunkWrapper'

const callNextProcessPhase = async (_, processId, deviceId) => {
  await nexus.command.nextPhase(processId, { deviceId })
}

export default thunkWrapper(callNextProcessPhase)
